import { render, staticRenderFns } from "./ViewImage2.vue?vue&type=template&id=73266a2a&scoped=true&"
import script from "./ViewImage2.vue?vue&type=script&lang=js&"
export * from "./ViewImage2.vue?vue&type=script&lang=js&"
import style0 from "./ViewImage2.vue?vue&type=style&index=0&id=73266a2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73266a2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VChip,VIcon})
